import React, { useState, useEffect, useContext } from 'react';
import context from '../context/recipesContext';
import { getDrinksByCategory } from '../services/getFoodsByCategory';

const getCategories = async () => {
  const maxSize = 5;
  const request = await fetch('https://www.thecocktaildb.com/api/json/v1/1/list.php?c=list');
  const { drinks } = await request.json();
  return drinks.slice(0, maxSize);
};

function FiltersDrinks() {
  const [categories, setCategories] = useState([]);
  const [currFilter, setCurrFilter] = useState('');
  const { setFilterDrinks, filterDrinks, setDrinks } = useContext(context);

  useEffect(() => {
    getCategories().then((data) => (setCategories(data)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getRecipes = async ({ target }) => {
    if (currFilter === target.id) {
      setFilterDrinks({ ...filterDrinks, filter: 'name' });
      setCurrFilter('');
    } else {
      setCurrFilter(target.id);
      setDrinks(await getDrinksByCategory(target.id));
    }
  };

  return (
    <div className="categories">
      <button
        data-testid="All-category-filter"
        className="category-btn"
        type="button"
        onClick={ () => {
          setFilterDrinks({ filter: 'name', value: '' });
          setCurrFilter('');
        } }
      >
        All
      </button>
      {
        categories && (
          categories.map((category, index) => (
            <button
              id={ category.strCategory }
              key={ index }
              type="button"
              className="category-btn"
              data-testid={ `${category.strCategory}-category-filter` }
              onClick={ getRecipes }
            >
              {category.strCategory}
            </button>))
        )
      }
    </div>
  );
}

export default FiltersDrinks;
